// The file contents for the current environment will overwrite these during build. 
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
//1n679nffm3.execute-api.us-west-2.amazonaws.com
//'giattsrpqa.execute-api.us-west-2.amazonaws.com/wlp/wlp-api-gw-resource-qa-01'
//https://ijg3jqrlli.execute-api.us-west-2.amazonaws.com/wlp
import * as CryptoJS from 'crypto-js';

let cv = '';

function generateRandomString(length: number): string {
  let text = '';
  const codeVerifier = localStorage.getItem('code_verifier');
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    cv = text;
    localStorage.setItem('code_verifier', cv);
    return text;
  }
}

function generateCodeChallenge(codeVerifier: string): string {
  const codeChallenge = base64URL(CryptoJS.SHA256(codeVerifier));
  return codeChallenge;
}

function base64URL(string: CryptoJS.lib.WordArray): string {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
}

export const environment = {
  production: false,
  envName: 'dev',
  hostname: 'devnew-02.wlp.toyota.com',
  _comment: '\'api\' key contains parameters to configure amazonaws API',
  api: {
    resourceName: 'ijg3jqrlli.execute-api.us-west-2.amazonaws.com/wlp/wlp-api-gw-resource-dev-02'
    // resourceName: '0t5v63i6jb.execute-api.us-west-2.amazonaws.com/wlp/wlp-api-gw-resource-qa-02'
  },
  wlpUrls: {
    wlpSetup: '/wlp-dev-02-us-west-2a-warehousesetup-0',
    warehouseTrailer: '/wlp-dev-02-us-west-2a-warehousetrailer-2',
    unloadPlan: '/wlp-dev-02-us-west-2a-unloadplan-1'
  },
  debugging: true,
  logger: {
    level: 'INFO'
  },
  azureConfig: {
    tenant: 'tmnatest.onmicrosoft.com',
    clientId:'e0bb2e54-2b88-420b-bc09-af6bd17843a1',
    response_type:'code',
    version: 'v2.0',
    redirect_uri:'https://devnew-02.wlp.toyota.com/',
   postLogoutRedirectUri: 'https://devnew-02.wlp.toyota.com/',
    // redirect_uri:'http://localhost:4200/',
    // postLogoutRedirectUri: 'http://localhost:4200/',
    extraQueryParameter:'scope=openid profile email user.read',
    response_mode:'query',  // Changed from 'fragment' to 'query' for authorization code flow
    state:'12345',
    nonce:'678910'
  },
  // baseLoginUrl: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize?client_id=e0bb2e54-2b88-420b-bc09-af6bd17843a1&response_type=code&redirect_uri=https://d8193qsyvsazk.cloudfront.net&response_mode=query&scope=openid&state=23343&code_challenge=' + generateCodeChallenge(cv),
  get baseLoginUrl() {
    // Use existing code verifier if available, otherwise generate a new one
    const codeVerifier = localStorage.getItem('code_verifier') || generateRandomString(128);
    if (!localStorage.getItem('code_verifier')) {
      localStorage.setItem('code_verifier', codeVerifier);
    }
    const codeChallenge = generateCodeChallenge(codeVerifier);
    // return `https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize?client_id=e0bb2e54-2b88-420b-bc09-af6bd17843a1&response_type=code&redirect_uri=http://localhost:4200/&response_mode=query&scope=openid%20profile%20email%20user.read&state=12345&code_challenge=${codeChallenge}&code_challenge_method=S256`;
    return `https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/authorize?client_id=e0bb2e54-2b88-420b-bc09-af6bd17843a1&response_type=code&redirect_uri=https://devnew-02.wlp.toyota.com/&response_mode=query&scope=openid%20profile%20email%20user.read&state=12345&code_challenge=${codeChallenge}&code_challenge_method=S256`;
  },
  // tokenURL: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token',
  tokenURL: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef/oauth2/v2.0/token',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  grantType: 'authorization_code',
  clientId: 'e0bb2e54-2b88-420b-bc09-af6bd17843a1',
  // redirectURI: 'https://qa.msrs.toyota.com',
  redirect_uri:'https://devnew-02.wlp.toyota.com/',
  redirectURI: 'https://devnew-02.wlp.toyota.com/',
  // redirect_uri:'http://localhost:4200/',
  // redirectURI: 'http://localhost:4200/',
  get codeVerifier() {
    return localStorage.getItem('code_verifier') || '';
  },
  get codeChallenge() {
    const verifier = this.codeVerifier;
    return verifier ? generateCodeChallenge(verifier) : '';
  }
  //: ***REMOVED***,
  //logoutUrl: 'https://cpssologin-dc2.toyota.com/tesslogin/logout.jsp?end_url=http%3a%2f%2fdev.t-ten.toyota.com'
};